export default "__VITE_ASSET__bP1c2nPK__"